module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/header/logo.png",
      "alt": "logo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lefttext"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/header/phone.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "righttext"
  }, [_vm._v("咨询热线：")]), _c('span', {
    staticClass: "tel"
  }, [_vm._v(_vm._s(_vm.tel))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01918716!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/header/HomeTitle.vue
// module id = 133
// module chunks = 1